import React from 'react';
import EndpointList from './EndpointList';
import * as API from 'modules/app/API.js';
import * as Help from 'modules/app/Help'

class EndpointsInfoTab extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState();
    }

    initialState = () => {
        return {
            environmentName: null,
            endpoints: []
        };
    }

    setHelp = () => {
        if (this.props.helpKey)
            Help.setHelp(this.props.helpKey)
        else
            Help.clearHelp();
    }

    componentDidMount() {
        var rq = {};

        API.App.get('/console/getEndpoints', rq, {
            success: (sr) => {
                this.setState({
                    environmentName: sr.data.environmentName,
                    endpoints: sr.data.items
                });
            }
        });

        this.setHelp();
    }

    render() {
        return (
            <React.Fragment>
                <EndpointList title={this.state.environmentName} endpoints={this.state.endpoints} />
            </React.Fragment>
        );
    }
}

export default EndpointsInfoTab;



// WEBPACK FOOTER //
// ./src/areas/admin/console/endpointsInfo/EndpointsInfoTab.js